import { getTranslate } from 'legacy-src/utilities/i18n'
import Markdown from 'markdown-to-jsx'
import React from 'react'

import { ButtonLink } from '@/legacy-src/components/ui/button'

import Icon from '../icons/Icon'

type Props = {
  readonly className?: string
}

const CounsellingTeaser: React.FC<Props> = ({ className }) => {
  const { t } = getTranslate()
  return (
    <div className={`flex w-full justify-center ${className}`}>
      <div className={`w-full rounded-3xl bg-white p-7 shadow-hedepy`}>
        <div className={`"-m-3 'tablet:flex-column' flex flex-col items-center text-center`}>
          <Icon icon="chat-bubbles" className="mr-3" color="primary" size="slg" />
          <div className={`p-3 text-center text-xl font-bold leading-6 tablet:!text-center`}>
            {t('component.counseling.banner.title')}
          </div>
          <div className="mb-7 text-sm text-text-color">
            <Markdown>{t(`component.counseling.banner.descActiveBenefit`)}</Markdown>
          </div>

          <div className="p-3 leading-6">
            <ButtonLink href={'/counselling'}>{t('component.counseling.startChat.button')}</ButtonLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CounsellingTeaser
